"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardFooter = exports.CardContent = exports.CardDescription = exports.CardTitle = exports.CardHeader = exports.Card = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
/**
 * RedPanda UI - Card Component
 * 統一的卡片元件，支援多種變體和深淺模式
 */
const react_1 = __importDefault(require("react"));
const utils_1 = require("../../utils");
const class_variance_authority_1 = require("class-variance-authority");
const cardVariants = (0, class_variance_authority_1.cva)('rounded-lg border bg-white shadow-sm transition-colors', {
    variants: {
        variant: {
            default: 'border-neutral-200 bg-white dark:border-neutral-800 dark:bg-neutral-800',
            elevated: 'border-neutral-200 bg-white shadow-md dark:border-neutral-800 dark:bg-neutral-800'
        }
    },
    defaultVariants: {
        variant: 'default'
    }
});
exports.Card = react_1.default.forwardRef(({ className, variant, ...props }, ref) => ((0, jsx_runtime_1.jsx)("div", { ref: ref, className: (0, utils_1.cn)(cardVariants({ variant }), className), ...props })));
exports.Card.displayName = 'Card';
exports.CardHeader = react_1.default.forwardRef(({ className, ...props }, ref) => ((0, jsx_runtime_1.jsx)("div", { ref: ref, className: (0, utils_1.cn)('flex flex-col space-y-1.5 p-6', className), ...props })));
exports.CardHeader.displayName = 'CardHeader';
exports.CardTitle = react_1.default.forwardRef(({ className, ...props }, ref) => ((0, jsx_runtime_1.jsx)("h3", { ref: ref, className: (0, utils_1.cn)('text-lg font-semibold leading-none tracking-tight text-neutral-900 dark:text-neutral-100', className), ...props })));
exports.CardTitle.displayName = 'CardTitle';
exports.CardDescription = react_1.default.forwardRef(({ className, ...props }, ref) => ((0, jsx_runtime_1.jsx)("p", { ref: ref, className: (0, utils_1.cn)('text-sm text-neutral-600 dark:text-neutral-400', className), ...props })));
exports.CardDescription.displayName = 'CardDescription';
exports.CardContent = react_1.default.forwardRef(({ className, ...props }, ref) => ((0, jsx_runtime_1.jsx)("div", { ref: ref, className: (0, utils_1.cn)('p-6 pt-0', className), ...props })));
exports.CardContent.displayName = 'CardContent';
exports.CardFooter = react_1.default.forwardRef(({ className, ...props }, ref) => ((0, jsx_runtime_1.jsx)("div", { ref: ref, className: (0, utils_1.cn)('flex items-center p-6 pt-0', className), ...props })));
exports.CardFooter.displayName = 'CardFooter';
